import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { Trophy } from 'lucide-react';
import type { ParameterComparison } from '@/lib/types/ds/prediction-error-evaluation';

interface ParameterComparisonTableProps {
  data: ParameterComparison[];
}

export function ParameterComparisonTable({ data }: ParameterComparisonTableProps) {
  if (data.length === 0) {
    return <p className="text-sm text-muted-foreground">比較データがありません</p>;
  }

  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-12"></TableHead>
            {data[0]?.target_date && <TableHead>基準日</TableHead>}
            <TableHead className="text-right">train_term</TableHead>
            <TableHead className="text-right">tolerance</TableHead>
            <TableHead className="text-right">max_data_count</TableHead>
            <TableHead className="text-right">WMAPE</TableHead>
            <TableHead className="text-right">Bias%</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.map((row, index) => (
            <TableRow key={index} className={row.is_best ? 'bg-yellow-50' : ''}>
              <TableCell>{row.is_best && <Trophy className="h-4 w-4 text-yellow-500" />}</TableCell>
              {row.target_date && <TableCell>{row.target_date}</TableCell>}
              <TableCell className="text-right">{row.train_term}</TableCell>
              <TableCell className="text-right">{row.tolerance}</TableCell>
              <TableCell className="text-right">{row.max_data_count}</TableCell>
              <TableCell className="text-right">
                <span className={row.is_best ? 'font-bold text-green-600' : ''}>
                  {(row.wmape * 100).toFixed(2)}%
                </span>
              </TableCell>
              <TableCell className="text-right">
                <Badge
                  variant="outline"
                  className={
                    row.bias_percent > 0
                      ? 'text-red-600 border-red-200'
                      : 'text-blue-600 border-blue-200'
                  }
                >
                  {row.bias_percent > 0 ? '+' : ''}
                  {(row.bias_percent * 100).toFixed(2)}%
                </Badge>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
